import { createContext, useContext } from 'react'
import { ContactParams } from '../../api/contacts/types'
import { ProjectParams } from '../../api/projects/types'
import { PropertyParams } from '../../api/properties/types'

/** The `params` shape a View page's GetEntity query (GetProject/GetProperty/GetContact/GetCompany) was called with. */
export type EntityParams = ProjectParams | PropertyParams | ContactParams

const EntityParamsContext = createContext<EntityParams | undefined>(undefined)

/**
 * Wraps a View page's content (ContactView/CompanyView/PropertyView/ProjectView),
 * passing the same `params` (criteria/order) its GetEntity query was called with. Every
 * AppPermissionsSwitcher nested inside, however deep, can
 * then read it via `useEntityParams` to match that query's cache key in `getQueryData`.
 */
export const EntityParamsProvider = EntityParamsContext.Provider

/** Reads the `params` provided by the nearest `EntityParamsProvider`, or `undefined` outside one. */
export const useEntityParams = () => useContext(EntityParamsContext)
